module.exports = __webpack_public_path__ + "assets/img/HR-Connect-Website.34956c21.webp";